if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    // TRACKING CLASSES TO SOCIAL NETWORKS
    function AddTrackingParameters( htmlElement, dataValue ){
        if(htmlElement) {
            htmlElement.classList.add('custom_click_track');
            htmlElement.dataset.custom_click_track_value = dataValue;
        }
    }

    // ( document.querySelector('header .header__right .social-media .facebook') )
    //     ? AddTrackingParameters( document.querySelector('header .header__right .social-media .facebook'), 'NavBar: Facebook|Social Site Click |external|event465' )
    //     : null;

    // ( document.querySelector('header .header__right .social-media .instagram') )
    //     ? AddTrackingParameters( document.querySelector('header .header__right .social-media .instagram'), 'NavBar: Instagram|Social Site Click |external|event465' )
    //     : null;

    // ( document.querySelector('footer .social-media .facebook') )
    //     ? AddTrackingParameters( document.querySelector('footer .social-media .facebook'), 'Footer: Facebook|Social Site Click |external|event465' )
    //     : null;

    // ( document.querySelector('footer .social-media .instagram') )
    //     ? AddTrackingParameters( document.querySelector('footer .social-media .instagram'), 'Footer: Instagram|Social Site Click |external|event465' )
    //     : null;

    // if( document.querySelector('form#email-signup button.signup-btn.custom_click_track ')) {
    //     let button = document.querySelector('form#email-signup button.signup-btn.custom_click_track ');
    //     button.dataset.custom_click_track_value = "Footer: |Email Sign Up Click|internal|event462";
    // }

})();